// Bump this whenever meaningful new content ships to the What's New page
// (Updates.jsx / WhatsNew/*.md). Compared against each user's
// uiPreferences.whatsNewSeenVersion to drive the unread pulse badge in the
// header - see components/mainFrame/header/WhatsNewBadge.jsx.
export const LATEST_WHATS_NEW_VERSION = '2026-11-02.1'
